$(function() {

  const tickerslide = document.querySelectorAll('.ticker');
  for( i=0; i< tickerslide.length; i++ ) {
      var ticker = document.querySelector(".ticker"),
      list = document.querySelector(".ticker__list"),
      clone = list.cloneNode(true);
      ticker.prepend(clone);
  }

  $('.collectionSlider').each(function(){
    var collectionswiper = new Swiper('.swiper-collection', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,

        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          960: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },

        navigation: {
          nextEl: '.swiper-button-forward',
          prevEl: '.swiper-button-back',
        },

      // If we need pagination
      // pagination: {
      //     el: '.swiper-pagination',
      //     type: 'bullets',
      //   },
    });
  });

  const myCustomSlider = document.querySelectorAll('.swiper-container-eateries');
  for( i=0; i< myCustomSlider.length; i++ ) {
    myCustomSlider[i].classList.add('swiper-container-eateries-' + i);
    var slider = new Swiper('.swiper-container-eateries-' + i, {
    /* Options */
      slidesPerView: 1,
      spaceBetween: 40,
      direction: 'horizontal',
      watchOverflow: true,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-container-eateries-' + i + ' .swiper-button-forward',
        prevEl: '.swiper-container-eateries-' + i + ' .swiper-button-back',
      },
    });
}

// $('.site-header__search-toggle').click(function (e) {
//   e.preventdefault();
// });

$('.js-load-more').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[loader]').removeClass('hide');
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.tw-grid').append($(responseHTML).find('.tw-grid').html());
    },
    complete: function() {
      if(currentPage <= totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      }
    }
  })
});


  // setup swiper slider
  // $('.swiper-container').each(function(){
  //   var mySwiper = new Swiper($(this)[0],{
  //     // Optional parameters
  //     direction: 'horizontal',
  //     // If we need pagination
  //     pagination: {
  //       el: '.swiper-pagination',
  //     },
  //     // Navigation arrows
  //     navigation: {
  //       nextEl: '.swiper-button-forward',
  //       prevEl: '.swiper-button-back',
  //     },
  //   });
  // });
});
